import Vue from "vue";
import ApiService from "./ApiService";
import { StorageService, TokenService } from "./StorageService";
import router from "../router/index";

const IDLE_LIMIT_MS = 15 * 60 * 1000;
const WARNING_MS = 60 * 1000; // aviso con contador durante el último minuto
const SESSION_MESSAGE_KEY = "session-expiration-message";
const ACTIVITY_THROTTLE_MS = 5000;
const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];
const DELIBERATE_EVENTS = ["click", "keydown", "touchstart"];

// Shared reactive store so any component (e.g. the warning dialog) can react to idle state.
export const idleBus = new Vue({
  data: () => ({
    warningVisible: false,
    secondsRemaining: 0
  })
});

let idleTimer = null;
let countdownTimer = null;
let started = false;
let lastActivityAt = 0;

function clearTimers() {
  clearTimeout(idleTimer);
  clearInterval(countdownTimer);
}

function hideWarning() {
  idleBus.warningVisible = false;
}

function showWarning() {
  idleBus.warningVisible = true;
  idleBus.secondsRemaining = Math.floor(WARNING_MS / 1000);
  countdownTimer = setInterval(() => {
    idleBus.secondsRemaining -= 1;
    if (idleBus.secondsRemaining <= 0) {
      clearInterval(countdownTimer);
      forceLogout();
    }
  }, 1000);
}

function scheduleWarning() {
  idleTimer = setTimeout(showWarning, IDLE_LIMIT_MS - WARNING_MS);
}

function resetTimer() {
  if (!started) {
    return;
  }
  clearTimers();
  hideWarning();
  scheduleWarning();
}

async function forceLogout() {
  IdleService.stop();
  hideWarning();
  Vue.notify({
    group: "app",
    type: "warning",
    text: "Su sesión se cerró por inactividad."
  });
  try {
    await ApiService.post("/auth/logout");
  } catch (error) {
    // el storage local se limpia igual aunque falle la notificación al backend
  }
  StorageService.clearStorage();
  ApiService.removeHeader();
  localStorage.setItem(SESSION_MESSAGE_KEY, "Su sesión se cerró por inactividad.");
  window.dispatchEvent(new Event("app:force-logout"));
  router.push({ path: "/login", query: { reason: "inactive" } });
}

function onActivity(event) {
  if (idleBus.warningVisible) {
    // Una vez se muestra el aviso, solo una acción deliberada lo cancela (no basta con mover el mouse).
    if (DELIBERATE_EVENTS.includes(event.type)) {
      resetTimer();
    }
    return;
  }
  const now = Date.now();
  if (now - lastActivityAt < ACTIVITY_THROTTLE_MS) {
    return;
  }
  lastActivityAt = now;
  resetTimer();
}

const IdleService = {
  start() {
    if (started || !TokenService.getToken()) {
      return;
    }
    started = true;
    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, onActivity, { passive: true }),
    );
    scheduleWarning();
  },

  stop() {
    started = false;
    clearTimers();
    hideWarning();
    ACTIVITY_EVENTS.forEach((evt) =>
      window.removeEventListener(evt, onActivity),
    );
  },

  continueSession() {
    resetTimer();
  }
};

// Keeps idle tracking in sync whenever the session is force-closed elsewhere.
window.addEventListener("app:force-logout", () => IdleService.stop());

export default IdleService;
